export enum OfficerTitleType {
    CEO = 1,
    President = 2,
    CFO = 3,
    Treasurer = 4,
    VicePresident = 5,
    Secretary = 6,
    Other = 7,
}
